<template>
    
    <div>
        <pageHeader @reloadPersonal="reloadPage" :showIndex="-1"></pageHeader>

        <div class="content_area clearfix">
            <div class="content_area_left fl">
                <div class="content_area_left_topUserInfo">
                    <div class="topUserInfo_bgImage">
						<img src="../../assets/images/userInfoBg.png" alt="" />
					</div>
                    <div class="topUserInfo_content">
                        <div class="topUserInfo_content_userIcon">
							<div class="user-edit">
								<a href="javascript:void(0);" @click="userIconClick">编辑</a>
							</div>
							<div v-if="userModel.avatar == 'null'|| userModel.avatar == null">
								<img src="../../assets/images/avatar.png" alt=""/>
							</div>
							<div v-else>
								<img :src="userInfoData.avatar" alt=""/>
							</div>
						</div>
                         <div class="topUserInfo_content_userName">
                            {{decodeURIComponent(userInfoData.nickName)}}
                            <i class="mini-medal mini-medal-one" v-if="userInfoData.memberLevel == 0"></i>
                            <i class="mini-medal mini-medal-two" v-else-if="userInfoData.memberLevel == 1"></i>
                            <i class="mini-medal mini-medal-three" v-else-if="userInfoData.memberLevel == 2"></i>
                            <i class="mini-medal mini-medal-four" v-else-if="userInfoData.memberLevel == 3"></i>
                            <i class="mini-medal mini-medal-five" v-else></i>

                        </div>
						<div>
							<div style="display:inline-block;width:50%">已加入 {{userInfoData.joinDays}} 天</div>
						
							<div style="display:inline-block;width:50%">
								已购买 {{userInfoData.courseCount}} 课
							</div>
						</div>
                        
                    </div>
                   
                    
                </div>
                <div class="left-menu">
                    <ul class="menu">
						<li class="perInfo" :class="{active:menuModel.isActive}" v-for="(menuModel,index) in menuList" :key="index">
							<a href="javascript:void(0)" @click="gotoSubViewController(menuModel.path,index)">
								<!-- <span v-html="menuModel.iconfont"></span> -->
								<span class="navIcon" :class="[menuModel.iconfont]"></span>
								<strong>{{menuModel.name}}</strong>
							</a>
						</li>
					</ul>
                </div>
            </div>
            <div class="content_area_right fl">
				<router-view></router-view>
			</div>
        </div>
        <pageFooter></pageFooter>

    </div>

</template>

<script>
import pageHeader from '../header/header'
import pageFooter from "../footer/pageFooter"
export default {
    components: {
        pageHeader,
        pageFooter
    },
    data() {
		return {
			isSignDay:false,	//是否签到
            userInfoData:{},    //学生信息
            userModel:{
                avatar:'',
                nickName:''
            },
            selectIndex:0,  //选中的子菜单
            menuList:[
					// {path:'myAccount',name:'我的账户',isActive:true},
				{path:'myCourse',name:'我的课程',iconfont:'myCourse',isActive:false},
				{path:'myShareCourse',name:'我的收藏',iconfont:'myShareCourse',isActive:false},
				{path:'myOrder',name:'我的订单',iconfont:'myOrder',isActive:false},
				
			],
        }
    },
    created () {
        if(localStorage.unread){
              this.messageStatus = localStorage.unread
        }else{
            this.messageStatus = 0
        }

        //加载用户信息
        this.getUserInfo();

		//查询签到情况
		this.getSignDayWithType(1,'0')
        var menuModel = this.menuList[localStorage.centerIndex]
		this.gotoSubViewController(menuModel.path,localStorage.centerIndex)
    },
    methods:{

		//签到
		goToSignDay: function() {
			if(this.isSignDay == true){
				return
			}
			this.getSignDayWithType(2,localStorage.userId)
		},
		// mobile/teacher/signDay （1：查询今日是否签到；2：签到） userId
		getSignDayWithType: function (type,userId){
			this.$http.post(this.baseUrl()+'/mobile/teacher/signDay',       // 还可以直接把参数拼接在url后边
				this.$qs.stringify({
                    type:type,
                    userId: userId,
                    token: localStorage.token
				}),{
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(function(res){

					if(res.data.flag==1){
						this.isSignDay = true;
					}
					this.getUserInfo();	//加载用户信息
                    
                }).catch(function (error) {
				console.log(error);
			});
		},
        getUserInfo: function (){

            this.$http.post(this.baseUrl()+'/user/center/obtainUser',
                this.$qs.stringify({userId:localStorage.userId}),
                {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }
            
            ).then((successResp) => {
					// console.log(successResp.body.data)
				this.userInfoData = successResp.body.data;
				this.userModel.avatar = this.userInfoData.avatar;
				if(this.userInfoData.nickName == null){
					this.userModel.nickName = this.userInfoData.studentName
				}else{
					this.userModel.nickName = this.userInfoData.nickName	
				}
			}, (failedResp) => {
					console.log(failedResp)
			})
        },
            
        reloadPage(){
            console.log("-----")
            var menuModel = this.menuList[localStorage.centerIndex]
			this.gotoSubViewController(menuModel.path,localStorage.centerIndex)
        },

        gotoSubViewController: function (path,selectIndex){
            localStorage.centerIndex = selectIndex
				
				// this.selectIndex = selectIndex
			for(var i =0;i<this.menuList.length;i++){
				var menuModel = this.menuList[i]
				if(i == localStorage.centerIndex){
					menuModel.isActive = true
						// console.log('=======')
				}else {
						// console.log('xxxxxxx')
					menuModel.isActive = false
				}
			}
				// console.log('presonalCenter......')
			this.$router.push({name:path,params: {memberName:this.userInfoData.memberName,phone:this.userInfoData.userName,memberLevel:this.userInfoData.memberLevel}})
		},
		//用户修改
		userIconClick: function() {
			localStorage.centerIndex = -1
			for(var i =0;i<this.menuList.length;i++){
				var menuModel = this.menuList[i]
				menuModel.isActive = false
			}
			this.$router.push('personalEdit')
				// this.$router.push('')
		},
    }
}
</script>

<style scoped>
.bgView {
	margin: 0 auto;
	width: 100%;
	background: #f7f7f7;	
}
/*内容区域*/
.content_area {
	margin: 0 auto 50px;
	width: 1200px;
}
/*内容区域左边部分*/
.content_area_left {
	margin-top: 20px;
}
/*内容区域左边部分 顶部用户信息*/
.content_area_left_topUserInfo {
	width: 280px;
	height: 259px;
	background: white;
}
/*内容区域左边部分 菜单列表*/
.content_area_left_menuList {
	margin-top: 10px;
	width: 280px;
	background: white;
	text-align: center;
}
/*内容区域右边部分*/
.content_area_right {
	/*width:900px;
	margin:20px 0 50px 20px;*/
    width: 908px;
    margin: 20px 0 50px 12px;
}

.topUserInfo_content {
	position:relative;
	top:-70px;
	text-align: center;
}

.user-edit {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background-color: rgba(0,0,0,0.5);
	border-radius:50px;
	display: none;
}
.user-edit a {
	display: inline-block;
	color: #fff;
	text-align: center;
	line-height: 100px;
}
.topUserInfo_content_userIcon {
	width: 100px;
	height: 100px;
	margin: 0 auto;
	margin-bottom: 10px;
	border-radius:55px;
	-moz-border-radius: 55px;
	-webkit-border-radius: 55px;
	overflow: hidden;
	position: relative;
	background-color: #fff;
	padding: 5px;
}
.topUserInfo_content_userIcon:hover .user-edit{
	display: block;
}
.topUserInfo_content_userIcon img{
	width: 100px;
	height: 100px;
	border-radius: 50px;
	-moz-border-radius: 50px;
	-webkit-border-radius: 50px;
	vertical-align: top;
}
.topUserInfo_content_userName {
	margin-bottom:10px;
	font-size: 16px;
}
.topUserInfo_content_integralShop {
	margin-bottom: 10px;
	font-size: 14px;
	color:#878787;
}
.topUserInfo_content_signin button{
	margin: 0 auto;
	width: 80px;
	height: 30px;
	background-color: #ffffff;
	color: #f49d40;
	border:1px solid #f49d40;
	outline: none;
	cursor: pointer;
}
.topUserInfo_content_signin button:hover{
	color: #fff;
	background-color: #f49d40; 
}
.topUserInfo_content_signin button.active{
	color: #999;
	background-color: #fff; 
	border-color: #adadad;
}
.content_area_left_menuList li {
	height: 50px;
	padding: 15px 0px;
}

.left-menu{
    width:280px;
	margin-top: 10px;
	display: inline-block;
	background: #fff;
	float: left;
}
.menu{
	margin-top:5px;
}
.menu li a{
	width: 100%;
	border-bottom: 1px solid #eee;
	text-align: center;
	display: inline-block;
	color: #666666;
	padding: 20px 0px;
	border-left: 3px solid #fff;
}
.menu li:last-child a{
	border-bottom: none;
}

.menu li a strong{
	/*display: block;*/
	line-height: 25px;
	display: inline-block;
	font-weight: normal;
	vertical-align: middle;
	margin-left: 8px;
}
	.navIcon{
		width: 25px;
		height: 23px;
		vertical-align: middle;
		display: inline-block;
		background-image:url(../../assets/images/left-nav.png);
		background-repeat: no-repeat;
	}
	.myLession{
		/*height: 23px;		*/
		background-position: 0 0;
	}
	.myShareLession{
		/*height: 21px;		*/
		background-position: 0 -46px;
	}
	.integralShop{
		/*height: 20px;		*/
		margin-left: -1px;
		background-position: 0 -98px;
	}
	.memberCenter{
		/*height: 23px;		*/
		margin-left: -1px;
		background-position: 0 -148px;
	}
	.myOrder{
		/*height: 21px;		*/
		margin-left: -2px;
		background-position: 0 -197px;
	}
	.myLessionReport{
		/*height: 17px;		*/
		margin-left: -1px;
		background-position: 0 -246px;
	}
	.myMessage{
		margin-left: -1px;
		background-position: 0 -290px;
	}
	.myAnswerQuestions{
		margin-left: -1px; 
		background-position: 0 -332px;
	}
    .menu li.active a,.menu li a:hover{
        border-left: 3px solid #f49d40;
        background: #eeeeee;
    }
</style>